<link rel="ractive" href="../r-page.html" name="r-page">
<link rel="ractive" href="../components/header.html" name="c-gp-header">
<link rel="ractive" href="../components/google-maps.html" name="c-google-maps">
<link rel="ractive" href="../components/footer.html" name="c-gp-footer">
<link rel="ractive" href="../components/notification.html" name="c-notification">
<link rel="ractive" href="../components/controlled-input.html" name="c-controlled-input">
<link rel="ractive" href="../components/show-more-link-list.html" name="c-show-more-link-list">

<r-page
	noYield="{{noYield}}"
	title="{{title}}"
	description="{{description}}"
	openGraphImage="{{@shared.serverHost}}/open-graph/image/networks/{{networkName}}"
>
	<c-notification></c-notification>

	<c-gp-header additionalClasses="header-with-globalping-bg"></c-gp-header>

	<div class="p-globalping-networks">
		<div class="p-globalping-networks_head">
			<h1 class="p-globalping-networks_head_title">Looking Glass - {{networkFullName}}</h1>

			{{#if asnList}} <!-- The component can't handle updates, so wait for the data first. -->
				<c-show-more-link-list method="{{selectedTestType}}" list="{{asnList}}" limit="4" prefix="AS" addClass="p-globalping-networks_head_asn-list"/>
			{{/if}}
		</div>

		<div class="p-globalping-networks_network">
			<div class="p-globalping-networks_network_head">
				<span>Network</span>

				{{#if networkLogoAsn}}
					<img width="32"
						height="32"
						src="/asn-logo/AS{{networkLogoAsn}}?v={{@shared.assetsVersion}}&size=64"
						loading="lazy"
						alt="{{networkFullName}} logo"
						as-tooltip="networkFullName"
						on-error="@this.set('networkLogoAsn', null)"
						>
				{{else}}
					<div class="p-globalping-networks_img-placeholder">{{networkFullName[0]}}</div>
				{{/if}}
			</div>

			<div class="p-globalping-networks_network_body">
				<div class="gp_dropdown_reg p-globalping-networks_network_body_select">
					<span>Location</span>

					<div class="btn-group">
						<button type="button"
							class="dropdown-toggle"
							data-toggle="dropdown"
							aria-haspopup="true"
							aria-expanded="false">
							<span class="dropdown-item">
								{{#if selectedLocation}}
								<img height="14"
									src="https://cdn.jsdelivr.net/npm/country-flag-icons@1.5.5/3x2/{{selectedLocation.countryCode}}.svg">
									{{~/selectedLocation.countryCode}},
									{{~/selectedLocation.city}}
								{{/if}}
							</span>
							<i class="fa fa-angle-down" aria-hidden="true"></i>
						</button>

						<ul role="listbox" class="dropdown-menu">
							{{#each ~/locationsList}}
								<li class="dropdown-item"
									aria-selected="{{this === selectedLocation}}"
									role="option"
									on-click="@this.setLocation(this)">
									<img height="14" src="https://cdn.jsdelivr.net/npm/country-flag-icons@1.5.5/3x2/{{this.countryCode}}.svg">
									{{this.countryCode}},
									{{this.city}}
								</li>
							{{/each}}
						</ul>
					</div>
				</div>

				<c-controlled-input
					id="ipAddress"
					value="{{userIP}}"
					userIP="{{userIP}}"
					error=""
					placeholder="Your IP"
					labelText="Your IP"
					classList="p-globalping-networks_network_body_input gp_input"
					locked="true">
					{{#partial copyBtn}}
						{{#if userIP}}
							<button
								class="p-globalping-networks_network_body_input_copy-btn"
								as-clipboard
								data-clipboard-text="{{userIP}}">
								Copy
							</button>
						{{/if}}
					{{/partial}}
				</c-controlled-input>
			</div>

			<div class="p-globalping-networks_network_map-wrapper {{#if mapExpanded}}is-expanded{{/if}}">
				<button type="button"
						aria-label="{{mapExpanded ? 'Collapse map' : 'Expand map'}}"
						on-click="@this.toggle('mapExpanded')">
					<img width="20" height="20" alt="" src="{{@shared.assetsHost}}/img/{{#if mapExpanded}}minimize-icon.svg{{else}}maximize-icon.svg{{/if}}">
				</button>
				<c-google-maps
						class="p-globalping-networks_network_map-wrapper_map"
						probesByCoords="{{probesByCoords}}"
						hasCluster="{{true}}"
						onMarkerClick="{{@this.onMarkerClick}}"
						displayInfoWindow="{{false}}"
						selectedLocation="{{selectedLocation}}"
						focusOnChange="{{true}}"
						lockMapBoundaries="{{true}}"
						mapMinZoom="{{2}}"
				/>
			</div>
		</div>

		<div class="p-globalping-networks_network-tests">
			<div class="p-globalping-networks_network_head">
				<span>Network tests</span>
			</div>

			<div class="p-globalping-networks_network-tests_body">
				<c-controlled-input
					id="ipOrHostname"
					value="{{testOpts.target}}"
					error="{{inputErrors.target}}"
					placeholder="IP or Hostname"
					labelText="IP or Hostname"
					classList="p-globalping-networks_network-tests_body_input gp_input">
				</c-controlled-input>

				<div class="gp_dropdown_reg p-globalping-networks_network-tests_body_select">
					<span>Method</span>

					<div class="btn-group">
						<button type="button"
							class="dropdown-toggle"
							data-toggle="dropdown"
							aria-haspopup="true"
							aria-expanded="false">
							<span>{{~/selectedTestType}}</span>
							<i class="fa fa-angle-down" aria-hidden="true"></i>
						</button>

						<ul role="listbox" class="dropdown-menu">
							{{#each ~/testTypesList}}
								<li aria-selected="{{this === selectedTestType}}"
									role="option"
									on-click="@this.setTestType(this)">
									{{this}}
								</li>
							{{/each}}
						</ul>
					</div>
				</div>

				<button type="button"
					on-click="@this.proceedToTest()"
					class=" p-globalping-networks_network-tests_body_btn-test gp_btn_green {{#if testInProgress}}gp_btn_green_disabled gp_btn_green_loading{{/if}}"
					data-testid="networks-run-test-btn"
					disabled="{{testInProgress || !selectedLocation}}">
					{{#if testInProgress}}
						<div></div>
						<div></div>
						<div></div>
						<div></div>
					{{else}}
						Run Test
					{{/if}}
				</button>
			</div>

			{{#if serverErrorMessage || creditErrorMessage}}
				<div class="p-globalping-networks_network-tests_fail-msg">
					<img width="56"
						height="56"
						alt="Fail icon"
						src="{{@shared.assetsHost}}/img/fail-icon-big.svg">

					<p>
						{{#if serverErrorMessage}}
							{{serverErrorMessage}}
						{{else}}
							{{{creditErrorMessage}}}
						{{/if}}
					</p>
				</div>
			{{elseif testResults}}
				<div class="p-globalping-networks_network-tests_results">
					<pre data-testid="networks-test-output"><em>{{measurementLocationText}}</em>{{testResults[0].result.rawOutput}}</pre>
				</div>
			{{else}}
				<div class="p-globalping-networks_network-tests_descr">
					<span class="p-globalping-networks_network-tests_descr_msg" data-testid="networks-test-placeholder">
						Enter a target and click <span class="highlighted">"Run Test"</span> to start a network test from:
						<br/>
						<span class="highlighted">{{selectedLocation.city}}, {{selectedLocation.country}}</span> with <span class="highlighted">{{networkFullName}}</span>.
					</span>
				</div>
			{{/if}}
		</div>

		{{#if otherNetworks.length}}
			<div class="p-globalping-networks_explore">
				<div class="p-globalping-networks_explore_head">
					Explore other networks
				</div>

				<div class="p-globalping-networks_explore_body">
					{{#each otherNetworks}}
						<a href="/networks/{{this.name}}" class="p-globalping-networks_explore_network" data-testid="other-network">
							{{#if this.networkLogoAsn}}
								<img width="24"
									height="24"
									src="/asn-logo/AS{{this.networkLogoAsn}}?v={{@shared.assetsVersion}}&size=48"
									loading="lazy"
									on-error="@this.onLogoError(this)"
									alt="{{this.fullName}} logo">
							{{else}}
								<span class="p-globalping-networks_img-placeholder-sm">{{this.fullName[0]}}</span>
							{{/if}}
							<span class="p-globalping-networks_explore_network_name">{{this.fullName}}</span>
						</a>
					{{/each}}
				</div>
			</div>
		{{/if}}

		{{#if shouldDisplayLogoDevLink}}
			<div class="p-globalping-networks_logos-by">
				<a data-testid="logo-dev-link" href="https://logo.dev" target="_blank" rel="noopener">Network logos provided by Logo.dev</a>
			</div>
		{{/if}}
	</div>

	<c-gp-footer></c-gp-footer>
</r-page>

<script>
	const _ = require('../../assets/js/_');
	const http = require('../../assets/js/utils/http');
	const dataCache = require('../../assets/js/utils/data-cache');
	const listeners = require('../../assets/js/utils/listeners');
	const tooltip = require('../../assets/js/decorators/tooltip');
	const countries = require('../../assets/json/countries.json');
	const DEFAULT_LIMIT = 1;
	const OTHER_NETWORKS_DISPLAYED = 12;
	const INITIAL_OPTS_VALUES = {
		type: 'Ping',
		target: 'cdn.jsdelivr.net',
	};
	const RATE_LIMIT_HEADERS = [
		'x-ratelimit-remaining',
		'x-ratelimit-reset',
		'x-credits-remaining',
		'x-request-cost',
	];
	const PROBE_NO_TIMING_VALUE = _.getProbeTimeOutValue();
	const PROBE_STATUS_OFFLINE = _.getProbeStatusOfflineValue();

	component.exports = {
		decorators: {
			tooltip,
		},
		data () {
			return {
				title: '',
				description: '',
				locationsList: [],
				selectedLocation: null,
				selectedTestType: 'ping',
				testTypesList: [ 'ping', 'traceroute', 'DNS', 'MTR', 'HTTP' ],
				probesResponse: null,
				probesParsed: false,
				userIP: null,
				asnList: [],
				networkLogoAsn: null,
				testResults: null,
				testInProgress: false,
				testReqCancelFn: null,
				testReqParams: null,
				testOpts: {
					target: INITIAL_OPTS_VALUES.target,
					limit: DEFAULT_LIMIT,
				},
				inputErrors: {},
				serverErrorMessage: null,
				creditErrorMessage: null,
				otherNetworks: [],
				probesByCoords: null,
				mapExpanded: false,
			};
		},
		computed: {
			shouldDisplayLogoDevLink () {
				let otherNetworks = this.get('otherNetworks');
				return this.get('networkLogoAsn') || (otherNetworks && otherNetworks.filter(n => n.networkLogoAsn).length);
			},
			measurementLocationText () {
				let testResults = this.get('testResults');

				if (!testResults || !testResults.length) {
					return '';
				}

				let probe = testResults[0].probe;

				return `> ${probe.city}${probe.state ? ` (${probe.state})` : ''}, ${probe.country}, ${probe.continent}, ${probe.network} (AS${probe.asn})\n`;
			},
		},
		onconfig () {
			let networkName = this.get('networkName');
			let tempNetworkName = this.getTempNetworkName(networkName);
			this.set('networkName', networkName);
			this.set('networkFullName', this.getTempNetworkName(networkName));
			this.setTitleAndDescr(tempNetworkName);
		},
		oninit () {
			if (!Ractive.isServer) {
				this.getGlobalpingProbesData();
				this.fetchAndSetUserIP();

				this.observe('networkFullName', (networkFullName) => {
					this.setTitleAndDescr(networkFullName);
				});

				// set default location value
				this.observe('locationsList', (locationsList) => {
					if (locationsList && locationsList.length) {
						this.set('selectedLocation', locationsList[0]);
					}
				});

				this.observe('probesParsed', async (probesParsed) => {
					if (probesParsed === false) { return; }

					let networkName = this.get('networkName');
					let parsedLocations = this.get('parsedLocations');
					let { name: networkFullName, asnList = [], locations = {}, probesByCoords = {} } = parsedLocations[networkName] || {};

					if (networkFullName) {
						this.set('networkFullName', networkFullName);
					} else {
						window.location.replace('/404');

						return;
					}

					let locationsList = Object.values(locations)
						.sort((lhs, rhs) => lhs.country.localeCompare(rhs.country) || lhs.city.localeCompare(rhs.city));

					this.set('asnList', asnList);
					this.set('networkLogoAsn', asnList[0] || null);
					this.set('locationsList', locationsList);
					this.set('probesByCoords', probesByCoords);

					let otherNetworks = await this.findOtherNetworks();
					this.set('otherNetworks', otherNetworks);
				});

				this.observe('realTimeTestResResponse', (realTimeTestResResponse) => {
					if (!realTimeTestResResponse) { return; }

					if (realTimeTestResResponse.status === 'finished') {
						this.get('testReqCancelFn')?.();
						this.set('testInProgress', false);
					}

					let prevTestResults = this.get('testResults') || [];
					let updTestResults = realTimeTestResResponse.results.filter((res) => {
						// if it is no in-progress then it is already finished or failed
						if (res.result.status !== 'in-progress') { return true; }

						return false;
					});

					// filter out results that have already been drawn
					let newTestResults = updTestResults.filter((updRes) => {
						return !prevTestResults.some(prevRes => JSON.stringify(prevRes) === JSON.stringify(updRes));
					});

					this.set('testResults', [ ...prevTestResults, ...newTestResults ]);
				}, { init: false });

				// set measurementsMetadata for the c-gp-results-share component
				this.observe('testReqParams', (testReqParams) => {
					if (!testReqParams) { return; }

					let measurementsMetadata = {
						0: {
							target: testReqParams.target,
							measurementId: testReqParams.id,
						},
					};

					this.set('measurementsMetadata', measurementsMetadata);
				});
			}
		},
		onrender () {
			if (!Ractive.isServer) {
				// run the test if user is pressed Enter inside of any of options inputs
				let ipOrHostnameEl = this.find('#ipOrHostname');
				listeners.addManagedListener(this, ipOrHostnameEl, 'keydown', this.handleEnterBtn.bind(this));
			}
		},
		onunrender () {
			this.get('testReqCancelFn')?.();
		},
		setLocation (newLocation) {
			this.set('selectedLocation', newLocation);
		},
		setTestType (newTestType) {
			this.set('selectedTestType', newTestType);
		},
		getGlobalpingProbesData () {
			// get probes from sessionStorage or fetch them
			dataCache.getCache('probesResponse', 60 * 1000, http.fetchGlobalpingProbes)
				.then((response) => {
					this.set('parsedLocations', this.parseProbesResponse(response));
					this.set('probesParsed', true);
				})
				.catch((error) => {
					console.error('Failed to fetch probes', error);
				});
		},
		async findOtherNetworks () {
			let networkName = this.get('networkName');
			let parsedLocations = this.get('parsedLocations');

			if (!parsedLocations || !networkName) {
				return [];
			}

			// create a sorted list of networks by the number of locations and name
			let sortedNetworks = Object.entries(parsedLocations)
				.sort((lhs, rhs) => lhs[1].probeCount - rhs[1].probeCount || lhs[0].localeCompare(rhs[0]));

			let currentNetworkIndex = sortedNetworks.findIndex(([ key ]) => key === networkName);

			// find ideal upper and lower network indices
			let upperBound = Math.ceil(OTHER_NETWORKS_DISPLAYED / 2);
			let lowerBound = Math.floor(OTHER_NETWORKS_DISPLAYED / 2);

			// find index over/underflows
			let upperOverflow = Math.max(0, (currentNetworkIndex + upperBound + 1) - sortedNetworks.length);
			let lowerUnderflow = Math.max(0, lowerBound - currentNetworkIndex);

			// correct the over/underflows
			let indexShift = lowerUnderflow - upperOverflow;
			let lowerIndex = currentNetworkIndex - lowerBound + indexShift;
			let upperIndex = currentNetworkIndex + upperBound + indexShift;

			// find similar networks
			let lowerNetworks = sortedNetworks.slice(lowerIndex, currentNetworkIndex);
			let upperNetworks = sortedNetworks.slice(currentNetworkIndex + 1, upperIndex + 1);

			return [ ...lowerNetworks, ...upperNetworks ].map(([ key, { name, asnList }]) => ({
				name: key,
				fullName: name,
				networkLogoAsn: asnList?.[0] || null,
			}));
		},
		parseProbesResponse (data) {
			let extractLocationInfo = (location) => {
				let country = countries.find(i => i.code.toLowerCase() === location.country.toLowerCase())?.name || location.country;
				let { city, latitude, longitude } = location;

				return { city, country, countryCode: location.country.split(', ')[0], latitude, longitude };
			};

			let byNetwork = data.reduce((res, probe) => {
				let { location } = probe;
				let { latitude, longitude, ...locationInfo } = extractLocationInfo(location);
				let networkNameAsKey = _.networkNameToKey(location.network);
				let coords = `${latitude}, ${longitude}`;
				let locationKey = `${location.country}, ${location.city}`;

				// collect uniques Networks and count amount of probes per Network
				if (!Object.hasOwn(res, networkNameAsKey)) {
					res[networkNameAsKey] = {
						name: location.network,
						asnList: [ location.asn ],
						probesByCoords: { [coords]: [ probe ] },
						locations: { [locationKey]: { ...locationInfo, coords: [{ latitude, longitude }] } },
						probeCount: 1,
					};

					return res;
				}

				res[networkNameAsKey].probeCount++;

				// collect all unique network's ASNs
				if (!res[networkNameAsKey].asnList.includes(location.asn)) {
					res[networkNameAsKey].asnList.push(location.asn);
				}


				// group probes by location (for select)
				if (!Object.hasOwn(res[networkNameAsKey].locations, locationKey)) {
					res[networkNameAsKey].locations[locationKey] = { ...locationInfo, coords: [] };
				}

				// group probes by coords (for the map)
				if (!Object.hasOwn(res[networkNameAsKey].probesByCoords, coords)) {
					res[networkNameAsKey].probesByCoords[coords] = [];
					res[networkNameAsKey].locations[locationKey].coords.push({ latitude, longitude });
				}

				res[networkNameAsKey].probesByCoords[coords].push(probe);

				return res;
			}, {});

			Object.values(byNetwork).forEach((network) => {
				network.asnList.sort((a, b) => a - b);
			});

			return byNetwork;
		},
		onMarkerClick ({ latitude, longitude }) {
			// find the location which contains the clicked marker's coordinates
			let newSelectedLocation
				= this.get('locationsList').find(loc => loc.coords.some(c => c.latitude === latitude && c.longitude === longitude));

			if (newSelectedLocation) {
				this.set('selectedLocation', newSelectedLocation);
			}
		},
		setTitleAndDescr (networkFullName) {
			this.set('title', `${networkFullName} Looking Glass - Globalping`);
			this.set('description', `Looking glass network tools for all ${networkFullName} locations`);
		},
		getTempNetworkName (networkName) {
			return _.capitalizeStrEveryFirstLetter(networkName.split('-').join(' '));
		},
		proceedToTest () {
			let type = this.get('selectedTestType').toLowerCase();
			let testOpts = this.get('testOpts');
			let { city, country } = this.get('selectedLocation');
			let networkFullName = this.get('networkFullName');
			let magic = `${city}+${country}+${networkFullName}`;
			let reqParams = {
				type,
				...testOpts,
				locations: [{ magic }],
			};

			// clear all data from the previous test, show spinner
			this.set('testResults', null);
			this.set('testInProgress', true);
			this.set('testReqParams', null);
			this.set('serverErrorMessage', null);
			this.set('creditErrorMessage', null);

			http.postGlobalpingMeasurement(reqParams, RATE_LIMIT_HEADERS).then((res) => {
				this.getTestMeasurementById(res.response.id);
			}).catch((err) => {
				let errBody = err?.error;
				this.set('testInProgress', false);

				if (errBody?.type === 'validation_error') {
					let inputErrors = _.parseValidationErrors(errBody);
					this.set('inputErrors', inputErrors);
				} else if (err?.responseStatusCode === 429) {
					let measurementErrMsg = _.createMeasCreditsErrMsg(
						err.responseHeaders,
						this.get('@shared.user'),
					);

					this.set('creditErrorMessage', measurementErrMsg);
				} else {
					this.set('serverErrorMessage', err.error?.message ?? 'An unexpected error occurred.');
				}
			});
		},
		getTestMeasurementById (measurementId) {
			let cancelled = false;
			let timeout = null;

			let cancel = () => {
				cancelled = true;
				clearTimeout(timeout);
				timeout = null;
			};

			let fetch = () => {
				if (cancelled) {
					return;
				}

				http.getGlobalpingMeasurement(measurementId).then((testRes) => {
					// prepare and set request params to pass them to gp-test-results
					let testReqParams = JSON.parse(JSON.stringify(testRes));

					delete testReqParams.results;
					delete testReqParams.status;
					delete testReqParams.updatedAt;
					delete testReqParams.createdAt;

					testReqParams = {
						inProgressUpdates: true,
						limit: DEFAULT_LIMIT,
						...testReqParams,
						measurementOptions: {
							trace: false,
							...testReqParams.measurementOptions,
						},
					};

					// set testReqParams to pass them to c-gp-results-raw-output
					this.set('testReqParams', testReqParams);

					// should be after the mainOptions.type was set
					this.set('realTimeTestResResponse', testRes);

					if (!cancelled) {
						timeout = setTimeout(fetch, 500);
					}
				}).catch(() => {
					cancel();
					this.set('serverErrorMessage', 'An unexpected error occurred.');
					this.set('testInProgress', false);
				});
			};

			fetch();
			this.set('testReqCancelFn', cancel);
		},
		prepareRegularResults (testResults) {
			let dnsTraceEnabled = this.get('testReqParams.measurementOptions.trace');
			let selectedTestType = this.get('selectedTestType');

			return testResults.map((res) => {
				let preparedRes = {
					...res.probe,
					statsPerTarget: [{
						target: res.target,
					}],
				};

				if (res.result.status !== 'in-progress') {
					let { isFailed = false, lastTiming, value: avgTiming, extraValues } = _.calcGpTestResTiming(selectedTestType, res, dnsTraceEnabled);
					let { packetsTotal } = _.parseGpRawOutputForTimings(res.result.rawOutput);
					let minTiming = res.result?.stats?.min || PROBE_NO_TIMING_VALUE;
					let maxTiming = res.result?.stats?.max || PROBE_NO_TIMING_VALUE;
					let isOffline = res.result.status === PROBE_STATUS_OFFLINE;

					preparedRes.statsPerTarget = [{
						...preparedRes.statsPerTarget[0],
						avgTiming,
						isFailed,
						isOffline,
						extraValues,
						rawOutput: res.result.rawOutput,
						areTimingsReady: this.checkAreTimingsReady(lastTiming, maxTiming, minTiming, avgTiming, packetsTotal),
					}];
				}

				return preparedRes;
			});
		},
		checkAreTimingsReady (lastTiming, maxTiming, minTiming, avgTiming, packetsTotal) {
			if (
				!packetsTotal
				|| typeof lastTiming === 'undefined'
				|| typeof maxTiming === 'undefined'
				|| typeof minTiming === 'undefined'
				|| typeof avgTiming === 'undefined'
			) {
				return false;
			}

			return true;
		},
		fetchAndSetUserIP () {
			fetch('https://cloudflare-dns.com/cdn-cgi/trace')
				.then(res => res.text())
				.then((text) => {
					let data = Object.fromEntries(text.trim().split('\n').map(line => line.split('=')));

					this.set('userIP', data.ip || null);
				})
				.catch((err) => {
					console.error('Failed to fetch user\'s IP:', err);
					this.set('userIP', null);
				});
		},
		onLogoError (network) {
			network.networkLogoAsn = null;
			// trigger re-render
			this.update('otherNetworks');
		},
		handleEnterBtn (event) {
			if (event.key === 'Enter') {
				event.preventDefault();
				this.proceedToTest();
			}
		},
	};
</script>
